import { notify } from '@billy/design-system'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { NotificationKeys } from '../../../enums/notificationKeys'
import { QueryKeys } from '../../../enums/queryKeys'
import { useSegment } from '../../../hooks'
import { fetchSkatConnection } from '../query-api'

interface UseSkatConnectionProps {
  cacheTime?: number
  isValidCVR?: boolean
  pollingEnabled?: boolean
  skatTransactionId?: string
  step?: 'Connecting' | 'Disconnecting'
}

const DEFAULT_REFETCH_INTERVAL = 3000

export const useConnectSkat = ({
  cacheTime,
  isValidCVR,
  pollingEnabled = false,
  skatTransactionId,
  step,
}: UseSkatConnectionProps = {}) => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { organization, isLoading: isOrganizationLoading } = useUserOrganization()
  const isCountryDenmark = organization?.countryId === 'DK'

  const organizationId = organization?.id

  const {
    data: skatConnection,
    isLoading: isSkatConnectionLoading,
    ...rest
  } = useQuery(
    [QueryKeys.SkatConnection, organizationId],
    () => fetchSkatConnection(organizationId || '', organization?.registrationNo, skatTransactionId),
    {
      enabled: !!organizationId && isValidCVR && isCountryDenmark,
      cacheTime,
      refetchInterval: pollingEnabled ? DEFAULT_REFETCH_INTERVAL : false,
      onError: () => {
        notify({
          id: NotificationKeys.SkatRequest,
          message: t('skat_form.connecting_error'),
          variant: 'error',
        })
        track('xxx - Bookkeeping - DK VAT integration', {
          flow: 'Failed',
          step: `3 - ${step}`,
        })
      },
    },
  )

  return {
    skatConnection,
    isLoading: isOrganizationLoading || isSkatConnectionLoading,
    ...rest,
  }
}
